import { css } from "@emotion/react";

import TwoFactorDisabledIcon from "assets/customIcons/security/TwoFactorDisabledIcon";
import TwoFactorEnabledIcon from "assets/customIcons/security/TwoFactorEnabledIcon";
import TwoFactorRecoveryCodesIcon from "assets/customIcons/security/TwoFactorRecoveryCodesIcon";
import { ENABLE_AUTHENTICATION_STEPS } from "shared";

import { IconProps } from "../types";

const Icon = ({ step }: IconProps) => {
    const getIcon = () => {
        switch (step) {
            case ENABLE_AUTHENTICATION_STEPS.RecoveryCodes:
                return <TwoFactorRecoveryCodesIcon />;
            case ENABLE_AUTHENTICATION_STEPS.SuccessMessage:
                return <TwoFactorEnabledIcon />;
            default:
                return <TwoFactorDisabledIcon />;
        }
    };

    return (
        <div
            css={css({
                "& > svg": {
                    fontSize: "144px"
                }
            })}
        >
            {getIcon()}
        </div>
    );
};

export { Icon };
